import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=bdfcac4a&scoped=true"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicModal.vue?vue&type=style&index=0&id=bdfcac4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfcac4a",
  null
  
)

export default component.exports